import angular from 'angular';
import PreferencesManageComponent from './preferences-manage.component';

const PreferencesManage = angular
    .module('control-room.app-settings.components.preferences-manage', [])
    .component('crPreferencesManage', PreferencesManageComponent);

export default PreferencesManage;
